import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { LicenseStateService } from 'src/app/services/license-state.service';
import { LicenseResponse } from 'src/app/api/models/license-response';
import { enumLicenseStatus } from '../pipes/license-status.pipe';

@Component({
  selector: 'app-nx-license-error-page',
  templateUrl: './nx-license-error-page.component.html',
  styleUrls: ['./nx-license-error-page.component.scss'],
})
export class NxLicenseErrorPageComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  data: LicenseResponse | null = null;
  status: string | undefined;
  isLoading = false;
  isRetrying = false;

  constructor(
    private licenseState: LicenseStateService,
    private router: Router
  ) {}

  ngOnInit() {
    this.licenseState.loadLicense();

    this.licenseState.data$.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.data = data;
    });

    this.licenseState.status$.pipe(takeUntil(this.destroy$)).subscribe(status => {
      this.status = status;

      if (this.isRetrying && status === enumLicenseStatus.ACTIVE) {
        this.isRetrying = false;
        this.router.navigateByUrl('/main/home');
      }
    });

    this.licenseState.isLoading$.pipe(takeUntil(this.destroy$)).subscribe(loading => {
      this.isLoading = loading;
      if (this.isRetrying && !loading) {
        this.isRetrying = false;
      }
    });
  }

  retry() {
    this.isRetrying = true;
    this.licenseState.loadLicense();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
